/* eslint-disable import/order */ /* <= reason: порядок импорта очень важен в этом месте  */
import { createApp } from 'vue';
import { createWebHashHistory, createRouter } from 'vue-router';
import { i18nSetup } from '@/i18n';
import VueIntercom from '@homebaseai/vue3-intercom';
import TextareaAutosize from 'vue-textarea-autosize';
// vue3-migration -- версия была обновлена
// import VueCurrencyInput from 'vue-currency-input';
import packageJson from '../package.json';
import config from './config';
import App from './App.vue';
import MainView from './views/Main';
import Request from './lib/request';
import routes from './routes';
import store from './store';
import Errors from './lib/errors';
import eventBus, { EventBusSetup } from './lib/eventBus';
import routeEvents from './lib/events';
import filters from './lib/filters';
import '@/assets/theme/common-page-styles.scss';
import './assets/sass/element_variables.scss';
import 'intl-tel-input/build/css/intlTelInput.css';
import InjectUi from '@/components/Report/Components/inject-ui';
import { fetchMiscSettings } from './helpers/fetchMiscSettings';
// vue3-migration -- версия была обновлена
import { VueReCaptcha } from 'vue-recaptcha-v3';
import randomizer from './helpers/randomizer';
import languages from '@/i18n/languages.json';
import { miscSetup } from '@/lib/misc';
import HighchartsVue from 'highcharts-vue';
import { SentrySetup } from '@/lib/sentry';
import { initTmAnalytics } from '@/lib/analytics';

const appmount = async () => {
  window.addEventListener('keydown', (ev) => {
    if (ev.code === 'F5' && location.hash.includes('/dashboard')) {
      ev.preventDefault();
      eventBus.$emit('window-refresh');
    }
  });

  const app  = createApp(App);

  try {
    const {
      payload: {
        recaptcha: { public_key },
        supported_languages,
      },
    } = await fetchMiscSettings();

    config.enabledLanguages = supported_languages.map((l) => ({ code: l, ...languages[l] }));

    app.use(VueReCaptcha, {
      siteKey: public_key,
      loaderOptions: {
        autoHideBadge: true,
      },
    });
  } catch (error) {
    console.error(error);
  }

  app.use(miscSetup, config);
  app.use(i18nSetup, config);
  // app.use(Vuelidate);
  app.use(Errors);
  app.use(filters);
  app.use(VueIntercom, { app_id: 'gijawcr0' });
  app.use(TextareaAutosize);
  // app.use(VueCurrencyInput);
  app.use(InjectUi);
  app.use(EventBusSetup);
  app.use(HighchartsVue);

  const router = createRouter({
    routes,
    linkActiveClass: 'active',
    history: createWebHashHistory(),
  });

  app.use(router);
  app.use(store);

  routeEvents(app, router);

  app.use(Request, {
    baseURL: config.api.baseURL,
    miscURL: config.api.miscURL,
    store,
    eventBus,
    router,
    errors: app.config.globalProperties.$errors,
    environment: config.environment,
  });

  await initTmAnalytics(store);

  app.config.globalProperties.$config = config;
  app.config.globalProperties.$appVersion = packageJson.version;

  if (app.hasOwnProperty('config') && app.config.hasOwnProperty('globalProperties')) {
    app.config.globalProperties.$randomizer = randomizer;
  } else {
    Object.defineProperty(app.prototype, '$randomizer', {
      value: randomizer,
      writable: false,
    });
  }

  app.use(MainView);

  // store.$app = app;

  // if (config.environment === 'test') {
  //   const Test = require('./test');
  //   Vue.use(Test.default);
  // }  

  if (process.env.NODE_ENV !== 'development') {
    app.use(SentrySetup, { router, config });
  }

  app.mount('#app');
};

appmount();
